import { render } from "./dummyTasks.vue?vue&type=template&id=6b877e6e&scoped=true&ts=true"
import script from "./dummyTasks.vue?vue&type=script&lang=ts"
export * from "./dummyTasks.vue?vue&type=script&lang=ts"

import "./dummyTasks.vue?vue&type=style&index=0&id=6b877e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b877e6e"]])

export default __exports__